
import { Component, Vue, Ref, Prop } from 'vue-property-decorator'
import TeacherSidemenuLayout from '@/components/organisms/layout/TeacherSidemenuLayout.vue'
import AcademySidemenuLayout from '@/components/organisms/layout/AcademySidemenuLayout.vue'
import AdminSidemenuLayout from '@/components/organisms/layout/AdminSidemenuLayout.vue'

/**
 * 管理権限用左側メニュー
 *
 *   権限共通で使用するテンプレート部品に対し、権限ごとのサイドメニューを切り替えるためのラッパーコンポーネント
 *   ページレベルからpropで該当権限を指定する
 *   特定権限でしか使用しないページには使わない
 */
@Component({
  components: {
    TeacherSidemenuLayout,
    AcademySidemenuLayout,
    AdminSidemenuLayout,
  },
})
export default class ManageSidemenuLayout extends Vue {
  /** サイドメニュー */
  @Ref()
  layoutByRole!: TeacherSidemenuLayout | AcademySidemenuLayout | AdminSidemenuLayout

  /** 教室権限 */
  @Prop({ default: false })
  private isTeacher!: boolean

  /** 塾管理権限 */
  @Prop({ default: false })
  private isAcademy!: boolean

  /** システム管理権限 */
  @Prop({ default: false })
  private isAdmin!: boolean

  /**
   * 指定された権限に応じたコンポーネントを返す
   *
   * @returns サイドメニューコンポーネント名
   */
  private get componentType(): string {
    if (this.isTeacher) {
      return 'TeacherSidemenuLayout'
    } else if (this.isAcademy) {
      return 'AcademySidemenuLayout'
    } else if (this.isAdmin) {
      return 'AdminSidemenuLayout'
    }

    // 一致しない場合、基本的に発生しない
    return ''
  }
}
